export default __webpack_public_path__ + "static/media/internshipArticleImage1.b6a10296.svg";